document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.logo-mobile-slider-container').forEach((sliderContainer) => {
    let currentIndex = 0;

    const slider = sliderContainer.querySelector('.logo-mobile-slider');
    const slides = sliderContainer.querySelectorAll('.logo-slide');
    const totalSlides = slides.length;
    const prevButton = sliderContainer.querySelector('.logo-prev');
    const nextButton = sliderContainer.querySelector('.logo-next');
    const pagination = sliderContainer.querySelector('.logo-pagination');

    pagination.innerHTML = '';

    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        currentIndex = i;
        updateLogoSlider();
      });
      pagination.appendChild(dot);
    });

    function moveLogoSlide(step) {
      currentIndex += step;
      if (currentIndex >= totalSlides) currentIndex = 0;
      if (currentIndex < 0) currentIndex = totalSlides - 1;
      updateLogoSlider();
    }

    function updateLogoSlider() {
      slider.style.transform = `translateX(-${currentIndex * 100}%)`;

      const dots = pagination.querySelectorAll('.dot');
      dots.forEach(dot => dot.classList.remove('active'));
      dots[currentIndex].classList.add('active');
    }

    prevButton.addEventListener('click', () => moveLogoSlide(-1));
    nextButton.addEventListener('click', () => moveLogoSlide(1));

    updateLogoSlider();
  });
});
